import { Separator } from 'components/Separator'
import { Header } from 'components/Header'
import { useAppInfo } from 'hooks/useAppInfo'
import { useGetAccountInfoAR } from 'services/account-info/useAccountInfo'

import { FlexColumn } from '@interco/inter-ui/components/Flex'
import { Text } from '@interco/inter-toranja'
import {
  TextSize,
  TextType,
  TextWeight,
} from '@interco/inter-toranja/dist/components/Atoms/Text/types'
import { Spacing } from '@interco/inter-ui/components/Spacing'

import { handleBackButton, hasWebViewHeader } from '../../../utils'
import { CardAR } from '../components/CardAR'
import { AccountInfoSkeleton } from '../AccountInfoSkeleton'
import { AccountInfoError } from '../AccountInfoError'
import { data } from './data'

interface AccountInfoARProps {
  language: string
  account: string
}

export const AccountInfoAR = ({ account, language }: AccountInfoARProps) => {
  const accountInfoAR = useGetAccountInfoAR(account, language)

  const { data: accountDetails, isFetching, isError, refetch } = accountInfoAR
  const { title } = data[language] ?? data['es-ES']

  const { appVersion, isDarkMode } = useAppInfo()
  const hasHeader = hasWebViewHeader(appVersion)

  const renderAccountInfoAR = () => {
    const accounts = accountDetails?.accounts

    if (isFetching) return <AccountInfoSkeleton isAR />
    if (isError || !accounts?.length) return <AccountInfoError refetch={refetch} />

    return (
      <>
        {hasHeader ? (
          <Header onClick={handleBackButton} isDarkMode={isDarkMode} />
        ) : (
          <Spacing mb="sm" />
        )}

        <FlexColumn className="px-[24px] gap-10">
          <Text
            textType={TextType.Title}
            textSize={TextSize.Large}
            state="enabled"
            as="h1"
            textWeight={TextWeight.Bold}
          >
            {title}
          </Text>

          <FlexColumn gap="40px">
            {accounts.map((conta, index) => (
              <>
                <CardAR item={conta} language={language} account={account} />
                {index < accounts.length - 1 && <Separator variant="line" />}
              </>
            ))}
          </FlexColumn>
        </FlexColumn>
      </>
    )
  }

  return renderAccountInfoAR()
}
